import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            看看大家都在讨论什么
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
              >
                <span className="text-xs font-semibold text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {topic.tag}
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {topic.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}